module.exports = __webpack_public_path__ + "5ea6821e0aaee472a3b6ef52363975f5.png";